import React from 'react'
import powerAppsLogo from '../assets/img/powertools-logo.png'
import { Link } from 'react-router-dom'

const HomeHeader = () => {
  return (
    <>
      <section className='header'>
      <nav class="navbar navbar-expand-sm bg-white navbar-white">
        <div class="container">
          <a class="navbar-brand" href="#"><img src={powerAppsLogo} height="50px" width="auto"/></a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="collapsibleNavbar">
            <ul class="navbar-nav ms-auto">
              <li class="nav-item">
                <a class="nav-link" href="#our-services">Our Services</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about-devcraft">About Us</a>
              </li>
              <li class="nav-item">
                <Link to="/contact-us"><a class="nav-link">Contact Us</a></Link>
              </li>
              <li class="nav-item">
              <Link to="/login"><a class="nav-link active">Login</a></Link>
              </li>  
            </ul>
          </div>
        </div>
      </nav>
      </section>
    </>
  )
}

export default HomeHeader